module.exports = __webpack_public_path__ + "static/media/multisport.33bd053f.png";